import { abbreviateNumber } from 'js-abbreviation-number';
import type { PortalView } from 'dfx/edge/edge.did';

export const getAbbreviatedMemberCount = (portalView: PortalView) => {
  return abbreviateNumber(Number(portalView.member_count), 1);
};
